import { H4 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
//@ts-expect-error Could not find declaration file for module
import playlistTableUrl from 'bender-url!../../../../images/playlist-table.svg';
import UIImage from 'UIComponents/image/UIImage';
import { AssignPlaylistButton } from '..';
import BlankPageMediaWrapper from '../../../components/BlankPageMediaWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PlaylistAssignmentsBlankPageContentForPlaylist = ({
  playlistId,
  portalId
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.blank.header"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.blank.body"
      })
    }), /*#__PURE__*/_jsx(AssignPlaylistButton, {
      block: true,
      className: "m-top-2",
      playlistId: playlistId,
      portalId: portalId,
      use: "secondary"
    })]
  });
};
const PlaylistAssignmentsBlankPage = ({
  playlistId,
  portalId
}) => {
  return /*#__PURE__*/_jsx(BlankPageMediaWrapper, {
    itemRight: /*#__PURE__*/_jsx(UIImage, {
      src: playlistTableUrl
    }),
    children: /*#__PURE__*/_jsx(PlaylistAssignmentsBlankPageContentForPlaylist, {
      playlistId: playlistId,
      portalId: portalId
    })
  });
};
export default PlaylistAssignmentsBlankPage;